import { createAction } from '@reduxjs/toolkit';
import { SortingFieldKey, SortingOrder } from './model';

export const sortingChanged = createAction<
  { order: SortingOrder; fieldKey: SortingFieldKey },
  'al/sorting/sortingChanged'
>('al/sorting/sortingChanged');
